import { CalendarSyncPair } from 'services/selfSchedulingServices';

/** MM-1168: one location of the Sync Calendar table with its providers. */
export interface SyncCalendarGroup {
  key: string;
  label: string;
  pairs: CalendarSyncPair[];
}

/** MM-1168: stable key of one office + provider pair, used for per-row state. */
export const pairKey = (pair: CalendarSyncPair) => `${pair.officeId}-${pair.providerId}`;

/**
 * MM-1168: keeps the pairs whose location or provider name contains the search text (case-insensitive),
 * then groups them by location. Locations and their providers are sorted by name.
 */
export const groupByLocation = (pairs: CalendarSyncPair[], search: string): SyncCalendarGroup[] => {
  const text = search.trim().toLowerCase();
  const groups = new Map<string, SyncCalendarGroup>();
  pairs
    .filter(
      (pair) =>
        !text ||
        (pair.officeName ?? '').toLowerCase().includes(text) ||
        (pair.providerName ?? '').toLowerCase().includes(text)
    )
    .forEach((pair) => {
      const key = `office-${pair.officeId}`;
      const group = groups.get(key) ?? { key, label: pair.officeName ?? '', pairs: [] };
      group.pairs.push(pair);
      groups.set(key, group);
    });
  const byName = (a: string, b: string) => a.localeCompare(b, undefined, { sensitivity: 'base' });
  return Array.from(groups.values())
    .map((group) => ({
      ...group,
      pairs: [...group.pairs].sort((a, b) => byName(a.providerName ?? '', b.providerName ?? '')),
    }))
    .sort((a, b) => byName(a.label, b.label));
};
